module.exports = __webpack_public_path__ + "static/media/instagram-brands.cc5e92b0.svg";